import { render, staticRenderFns } from "./Guardian.vue?vue&type=template&id=7b72fb90&"
import script from "./Guardian.vue?vue&type=script&lang=js&"
export * from "./Guardian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports